import type { ComponentType } from 'react';
import type { PanelContentProps } from './PanelNavigationContext';

export type PanelRegistryEntry = {
  id: string;
  title: string;
  component: ComponentType<PanelContentProps>;
  deepLinkable: boolean;
};

const PANEL_REGISTRY = new Map<string, PanelRegistryEntry>();

export function registerPanel(entry: PanelRegistryEntry): void {
  if (PANEL_REGISTRY.has(entry.id)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`[PanelRegistry] Duplicate panel ID: "${entry.id}". Overwriting.`);
    }
  }
  PANEL_REGISTRY.set(entry.id, entry);
}

export function getRegisteredPanel(id: string): PanelRegistryEntry | undefined {
  return PANEL_REGISTRY.get(id);
}

export function isRegisteredPanelId(id: string): boolean {
  return PANEL_REGISTRY.has(id);
}

export function getRegisteredPanelIds(): ReadonlySet<string> {
  return new Set(PANEL_REGISTRY.keys());
}

/**
 * Clears the registry. Only for use in tests.
 */
export function clearPanelRegistry(): void {
  PANEL_REGISTRY.clear();
}
